<p-dialog header="Error" [(visible)]="errorMessage" [draggable]="false" [modal]="true">
  <p class="text-danger">{{errorMessage}}</p>
  <ng-template pTemplate="footer">
      <button type="button" pButton pRipple class="p-button p-button-outlined" label="Ok" icon="pi pi-check" (click)="errorMessage=''"></button>
  </ng-template>
</p-dialog>

<form #form="ngForm">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--From Date-->
    <div class="p-field p-col-12 p-md-6">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="fromDate"
                    name="fromDate"
                    [(ngModel)]="fromDate"
                    ></p-calendar>
        <label for="fromDate" class="required-field">From</label>
      </span>
    </div>
  </div>

  <!-- Roster Code -->
  <div class="p-fluid p-grid">
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <p-multiSelect [options]="employees" 
                    inputid="employee"
                    name="employee"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    dataKey="id"
                    scrollHeight="150px"
                    selectedItemLabel="{0} employees selected"
                    filter="true" 
                    filterBy="firstName,lastName"
                    [(ngModel)]="selectedEmployees">
          <ng-template let-value pTemplate="selectedItems">
              <ng-container *ngIf="value && value.length <= 4">
                <span *ngFor="let option of value">
                  {{option.lastName}}, {{option.firstName}}; 
                </span>
              </ng-container>
              <div *ngIf="value && value.length > 4">{{value.length}} employees selected</div>
              <div *ngIf="!value || value.length === 0">Select employees</div>
          </ng-template>                      
          <ng-template let-employee pTemplate="item">
            <div class="country-item">
              <div>{{employee.lastName}}, {{employee.firstName}}</div>
            </div>
          </ng-template>
        </p-multiSelect >
        <label for="employee" class="required-field">Select employees:</label>
      </span>
    </div>
  </div>

  <div class="p-fluid p-formgrid-del p-grid">
    <!--Roster Note-->
    <div class="p-field p-col-12 p-md-12">
      <span class="p-float-label">
        <textarea pInputTextarea class="p-inputtext-sm"
          id="deletionNote"
          name="deletionNote" 
          rows="10"
          [(ngModel)]="deletionNote"></textarea>
        <label for="deletionNote">Enter note here (optional).</label>
      </span>
    </div>
  </div> 

  <div class="modal-footer">
    <button pButton pRipple label="Delete" 
            class="p-button p-button-raised p-button-danger" type="button" 
            icon="fas fa-check"
            (click)="delete();"></button>
    <button type="button" pButton pRipple class="p-button p-button-outlined" label="Cancel" icon="pi pi-times" (click)="cancel()"></button>
  </div>
</form>
